export default __webpack_public_path__ + "static/media/article_rocket.1ce76f7f.png";